import styled from "styled-components";

export const Wrap = styled.div`
  padding-right: 10px;
  min-width: 200px;
  border-inline-end: ${({ isFeaturesHidden }) =>
    isFeaturesHidden ? "non" : "1px dotted white"};
  margin-inline-end: ${({ isFeaturesHidden }) =>
    isFeaturesHidden ? 0 : "15px"};
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 530px) {
    border: none;
    margin-right: 0;
  }
`;
